import { Card, CardContent } from "~/shadcn/ui/card"
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "~/shadcn/ui/table"

// Static, fictional sample content shown blurred behind the Marketplace
// upgrade card (ZAN-921). Nothing here comes from the API.

type TeaserTableProps = {
  columns: string[]
  rows: string[][]
}

const TeaserTable = ({ columns, rows }: TeaserTableProps) => (
  <div className="h-full pb-4">
    <Card className="h-full overflow-hidden">
      <CardContent className="p-6 pt-4">
        <div className="h-10 mb-4 rounded-md bg-gray10" />
        <Table>
          <TableHeader>
            <TableRow>
              {columns.map((column) => (
                <TableHead key={column}>{column}</TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row[0]}>
                {row.map((cell, index) => (
                  <TableCell key={`${row[0]}-${index}`}>{cell}</TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  </div>
)

const SAMPLE_CREATORS = [
  ["Avery Lane", "Beauty", "United States", "1.2M", "Exclusive"],
  ["Jordan Reyes", "Fitness", "Canada", "845K", "Non-exclusive"],
  ["Sam Okafor", "Travel", "United Kingdom", "2.4M", "Exclusive"],
  ["Riley Chen", "Gaming", "Australia", "512K", "Exclusive"],
  ["Morgan Diaz", "Food", "Mexico", "1.9M", "Non-exclusive"],
  ["Casey Novak", "Fashion", "Germany", "730K", "Exclusive"],
  ["Taylor Brooks", "Lifestyle", "United States", "3.1M", "Non-exclusive"],
  ["Quinn Patel", "Tech", "India", "968K", "Exclusive"],
]

export const RosterDatabaseTeaser = () => (
  <TeaserTable
    columns={["Name", "Category", "Country", "Followers", "Exclusivity"]}
    rows={SAMPLE_CREATORS}
  />
)

const SAMPLE_AGENCIES = [
  ["Northlight Talent", "48", "12.4M", "8.1M"],
  ["Harbor & Co Creators", "35", "9.7M", "5.2M"],
  ["Summit Social", "29", "7.3M", "6.6M"],
  ["Bright Path Agency", "22", "5.9M", "3.4M"],
  ["Meridian Collective", "18", "4.1M", "2.8M"],
  ["Open Field Talent", "14", "3.2M", "1.9M"],
]

export const TalentAgenciesTeaser = () => (
  <TeaserTable
    columns={["Agency", "Influencers", "TikTok", "Instagram"]}
    rows={SAMPLE_AGENCIES}
  />
)

const SAMPLE_STATS = [
  ["Top categories", "Beauty · Fitness · Travel"],
  ["Top countries", "United States · United Kingdom · Canada"],
  ["Top creator types", "Influencer · UGC · Streamer"],
  ["Average TikTok video rate", "$1,250"],
]

export const DashboardTeaser = () => (
  <div className="grid grid-cols-2 gap-4">
    {SAMPLE_STATS.map(([label, value]) => (
      <Card key={label}>
        <CardContent className="p-6">
          <p className="text-gray50">{label}</p>
          <p className="text-xl font-semibold">{value}</p>
        </CardContent>
      </Card>
    ))}
  </div>
)
